import { Button as DSButton } from '@hivebrite/design-system/Button';
import { useTheme } from '@hivebrite/design-system/Theme';

import { INITIAL_STRIPS_IMAGES } from 'hb-builder/components/BuilderComponents/block/Strips/TemplateWithPlainImages/constants';
import { getStripItemChildren } from 'hb-builder/components/BuilderComponents/block/Strips/TemplateWithPlainImages/constants/childrenComponents';
import type { TemplateWithPlainImagesFrame } from 'hb-builder/components/BuilderComponents/block/Strips/types/items';
import type { AddFrameButtonProps } from 'hb-builder/components/BuilderComponents/block/Strips/types/props';
import {
  useBuilderContext,
  useBuilderConfigContext,
  useComponentsContext,
} from 'hb-builder/hooks';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import { getNewFrame } from './utils';

const MAX_FRAME = 12;

const AddFrameButton = ({
  getChildrenLength,
  item: stripsItem,
  type,
}: AddFrameButtonProps) => {
  const { addItem, getPath } = useBuilderContext();
  const { features } = useBuilderConfigContext();
  const featureFlags = useFeatureFlag();
  const theme = useTheme();

  const { components } = useComponentsContext();
  const { TemplateWithPlainImagesStripsItem } = components;

  if (!stripsItem || !type) {
    return null;
  }

  const { attributes: { fields } = { fields: {} } } = stripsItem;

  const initialStripsImages = INITIAL_STRIPS_IMAGES({
    features,
  });

  const newFrameIndex = getChildrenLength();
  const imageIndex = newFrameIndex % initialStripsImages.length;

  const addFrame = () => {
    const frame = TemplateWithPlainImagesStripsItem?.item({
      children: getStripItemChildren({
        components,
        featureFlags,
        features,
        image: initialStripsImages[imageIndex],
        stripsItem,
        theme,
      }),
      template: type,
    }) as TemplateWithPlainImagesFrame;

    const newFrame = getNewFrame({ frame, fields });

    addItem({
      direction: newFrameIndex + 1,
      id: stripsItem.id,
      item: newFrame,
      path: getPath(stripsItem.id),
    });
  };

  return (
    <DSButton
      isDisabled={stripsItem.children?.length === MAX_FRAME}
      m="10px 20px"
      onClick={addFrame}
      variant="primary"
    >
      {__('Add frame')}
    </DSButton>
  );
};

export default AddFrameButton;
